import React, { useState, useEffect } from 'react';
import usePermissions from 'hooks/permissions-hooks';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Tabs, Tab, Box } from '@material-ui/core';
import ManagerNewCorporate from 'components/business/local-manager/ManagerNewCorporate';
import ManagerNewBranch from 'components/business/local-manager/ManagerNewBranch';
import ManagerCorporationTable from 'components/business/local-manager/ManagerCorporationTable';
import { roles } from '../cassandra-shared-js/roles';

const useStyles = makeStyles({
  title: {
    margin: '0px 0px 5px 5px',
    color: 'rgb(100, 141, 174)',
    fontSize: 35,
  },
  tabRoot: {
    marginLeft: '8px',
    textTransform: 'none',
    backgroundColor: '#ffffff',
    fontSize: '16px',
    color: 'rgb(100, 141, 174)',
    border: '1px solid #ccc',
    minWidth: 180,
    '&:hover': {
      color: '#ffffff',
      backgroundColor: 'rgb(100, 141, 174)',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#ffffff',
      backgroundColor: 'rgb(100, 141, 174)',
      fontWeight: 'bold',
      fontSize: '18px',
    },
  },
  tabSelected: {},
});

// for tabs selection
function a11yProps(index) {
  return {
    id: `simple-tab-${ index }`,
    'aria-controls': `simple-tabpanel-${ index }`,
  };
}

// Function for Tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      hidden={ value !== index }
      id={ `simple-tabpanel-${ index }` }
      aria-labelledby={ `simple-tab-${ index }` }
      { ...other }
    >
      {value === index && (
        <Box p={ 3 }>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function ManagerCorporatePage() {
  const classes = useStyles();
  const [ country, setCountry ] = useState('GR');
  const { userHasRole, role } = usePermissions();
  const [ tab, setTab ] = useState(0);

  // Select Country
  useEffect(() => {
    if (userHasRole(roles.AL_MANAGER)) {
      setCountry('AL');
    } else if (userHasRole(roles.ADMINISTRATOR_ROLE)) {
      setCountry('GR');
    }
  }, [ role ]);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box pt={ 2 }>
      <div className={ classes.title }>
        Corporations Management
      </div>
      <Tabs
        className={ classes.customTabs }
        value={ tab }
        onChange={ handleChange }
        aria-label='corporate tabs'
        indicatorColor='primary'
        textColor='rgb(100, 141, 174)'
      >
        <Tab
          label='Add New Corporate'
          { ...a11yProps(0) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        />
        <Tab
          label='Add New Branch'
          { ...a11yProps(1) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        />
        <Tab
          label='All Corporates'
          { ...a11yProps(2) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        />
      </Tabs>
      <TabPanel value={ tab } index={ 0 }>
        <ManagerNewCorporate />
      </TabPanel>
      <TabPanel value={ tab } index={ 1 }>
        <ManagerNewBranch />
      </TabPanel>
      <TabPanel value={ tab } index={ 2 }>
        <ManagerCorporationTable country={ country } setCountry={ setCountry } />
      </TabPanel>
    </Box>
  );
}

export default ManagerCorporatePage;
